import Button from '@atlaskit/button';
import CrossIcon from '@atlaskit/icon/core/cross';
import { useDatabaseContent } from '@databases/database-state';
import {
  type BrokenDatabase,
  type Database,
  type DatabaseField,
  type EntryCreateOptions,
  type EntryWithContext,
} from '@databases/types/database';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../../i18n';
import EmbedReferencePicker from '../embedReferencePicker/EmbedReferencePicker';

import {
  FormHeaderContainer,
  FormTitle,
  ReferenceOptionsContainer,
} from './embedReferenceOptions.styles';

export interface EmbedReferenceOptionsProps {
  setSelectedDatabase: (value: Database | BrokenDatabase | undefined) => void;
  selectedDatabase: Database | BrokenDatabase | undefined;
  setSelectedEntry: (value: EntryWithContext | EntryCreateOptions | undefined) => void;
  selectedEntry: EntryWithContext | EntryCreateOptions | undefined;
  setSelectedField: (value: DatabaseField | undefined) => void;
  selectedField: DatabaseField | undefined;
  databaseError: boolean;
  isEmptySubmit: boolean;
  setIsEmptySubmit: (isEmptySubmit: boolean) => void;
}

export const cancelDatabaseReference = () => {
  window.parent.postMessage(
    JSON.stringify({ cancelDatabaseReference: true }),
    window.location.origin
  );
};

const EmbedReferenceOptions: FunctionComponent<EmbedReferenceOptionsProps> = ({
  setSelectedDatabase,
  selectedDatabase,
  setSelectedEntry,
  selectedEntry,
  setSelectedField,
  selectedField,
  databaseError,
  isEmptySubmit,
  setIsEmptySubmit,
}) => {
  const { formatMessage } = useIntl();
  const { spaceKey } = useDatabaseContent();

  return (
    <ReferenceOptionsContainer>
      <FormHeaderContainer>
        <FormTitle>{formatMessage(messages['reference-picker.header'])}</FormTitle>
        <Button
          appearance="subtle"
          iconBefore={
            <CrossIcon label={formatMessage(messages['reference-picker.close'])} />
          }
          onClick={cancelDatabaseReference}
          testId={'reference-close-button'}
        />
      </FormHeaderContainer>
      <EmbedReferencePicker
        spaceKey={spaceKey}
        setSelectedDatabase={setSelectedDatabase}
        selectedDatabase={selectedDatabase}
        setSelectedEntry={setSelectedEntry}
        selectedEntry={selectedEntry}
        setSelectedField={setSelectedField}
        selectedField={selectedField}
        handleCancel={cancelDatabaseReference}
        databaseError={databaseError}
        isEmptySubmit={isEmptySubmit}
        setIsEmptySubmit={setIsEmptySubmit}
      />
    </ReferenceOptionsContainer>
  );
};

export default EmbedReferenceOptions;
